// ABOUTME: Content footer for the detail panel — shows last edit metadata, unsaved changes warning, and Save/Discard buttons.
// ABOUTME: Two visual states: idle (disabled buttons with opacity-30) and unsaved changes (warning text + active buttons).
import {Button, LabelMedium} from '@hm/fundamental'
import React from 'react'

import {useTranslation} from '../../../../hooks/useTranslation'
import {useEntityLastEdit} from '../hooks/useEntityLastEdit'
import {EntityContentFooterProps} from '../types'

export const EntityContentFooter: React.FC<EntityContentFooterProps> = ({
  onSave,
  onDiscard,
  hasUnsavedChanges,
  isLoading,
  isSaving,
  hasErrors
}) => {
  const {lastEditDate, lastEditAuthor} = useEntityLastEdit()
  const {t} = useTranslation()

  if (isLoading) {
    return null
  }

  const hasLastEdit = lastEditDate && lastEditAuthor

  return (
    <div className="shrink-0 h-[72px] border-t border-border flex items-center justify-between px-6 py-4">
      <div className="flex flex-col gap-0.5">
        {hasUnsavedChanges && (
          <LabelMedium className="text-warning">
            {t('countryConfigurations.entity.footer.unsavedChanges')}
          </LabelMedium>
        )}
        {hasLastEdit && (
          <div className="flex items-center gap-1.5">
            <LabelMedium className="text-foreground_faded">
              {t('countryConfigurations.entity.footer.lastEdit', {date: lastEditDate})}
            </LabelMedium>
            <span className="h-2.5 w-px bg-foreground_faded inline-block" />
            <LabelMedium className="text-foreground_faded">{lastEditAuthor}</LabelMedium>
          </div>
        )}
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          type="button"
          size="regular"
          disabled={!hasUnsavedChanges}
          className={!hasUnsavedChanges ? 'opacity-30' : ''}
          onClick={onDiscard}
        >
          {t('countryConfigurations.entity.footer.discard')}
        </Button>
        <Button
          variant="primary"
          type="button"
          size="regular"
          disabled={!hasUnsavedChanges || isSaving || hasErrors}
          className={!hasUnsavedChanges ? 'opacity-30' : ''}
          onClick={onSave}
        >
          {t('countryConfigurations.entity.footer.save')}
        </Button>
      </div>
    </div>
  )
}
